module.exports = __webpack_public_path__ + "img/stepIcon.aab1327f.png";